import { PaletteMode } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { createPaletteDark } from './dark';
import { createPaletteLight } from './light';

export const resolvePalette = (mode: PaletteMode) => {
	const paletteOptions = mode === 'dark' ? createPaletteDark() : createPaletteLight();
	const { palette } = createTheme({ palette: paletteOptions });
	return palette;
};
